<template>
  <modal
    modal-class="templates-modal"
    size="xl"
    ref="modalComponent"
    :show="show"
    @hidden="$emit('input', false)"
    @shown="onShown"
    :scrollable="false"
    :hide-footer="true"
    :hide-header="true"
    :show-close-icon="true"
  >
    <div class="templates-wrapper">
      <div v-if="isAIFeatureAllowed">
        <north-a-i-templates-header />
        <div class="goal-container content d-flex justify-content-center px-3">
          <goal-a-i-templates :org-id="orgId" class="w-100" @select="onGoalSelect" />
        </div>
      </div>
      <div>
        <h2 class="text-extra-large text-center my-4 pb-3" v-if="isAIFeatureAllowed">
          Or pick from our goal templates library
        </h2>
        <h2 class="text-extra-extra-large text-center my-4 pb-3" v-else>
          Goal templates to help you get started
        </h2>
        <div class="goal-container d-flex justify-content-center px-3">
          <goal-templates
            class="goals-list content"
            :filter-data="filterData"
            :org-id="orgId"
            @filter="onFilter"
            @reset-filter="resetFilter"
            @select="onGoalSelect"
          />
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
import GoalAITemplates from '@/components/templates/GoalAITemplates.vue'
import GoalTemplates from '@/components/templates/GoalTemplates'
import NorthAITemplatesHeader from '@/components/templates/NorthAITemplatesHeader.vue'
import { featureFlags } from '@/constants/featureFlags'
import { TEMPLATE_TYPE } from '@/constants/goal'
import FeaturesMixin from '@/mixins/FeaturesMixin'

/**
 * This shows goal templates in a Modal
 */
export default {
  name: 'TemplatesModal',
  mixins: [FeaturesMixin],
  props: ['show', 'orgId'],
  model: {
    prop: 'show'
  },
  components: {
    GoalAITemplates,
    Modal,
    GoalTemplates,
    NorthAITemplatesHeader
  },
  data() {
    return {
      filterData: {},
      TEMPLATE_TYPE,
      isAIFeatureAllowed: this.getFeatureFlagValue(this.orgId, featureFlags.ALLOW_AI)
    }
  },
  methods: {
    onFilter({ field, fieldValue }) {
      this.filterData = { ...this.filterData, [field]: fieldValue.join(',') }
    },
    resetFilter() {
      this.filterData = {}
    },
    onGoalSelect(goal) {
      this.$emit('select', goal)
      this.$refs.modalComponent.hide()
    },
    onShown() {
      // On opening the modal, we are focusing North AI input field, because of which modal is shown in scrolled state. Below line is to reset the scroll.
      document.querySelector('.templates-modal').parentElement.scrollTop = 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.goals-list {
  min-height: 400px;
}

.content {
  width: 80%;
  margin: 0 auto;
}
.sub-title {
  max-width: 450px;
  margin: 0 auto;
}

.templates-wrapper {
  min-height: 85vh;
}
@include media-breakpoint-down(md) {
  .content {
    width: 100%;
  }
}
</style>
